import ApiInterface from "utils/ApiInterface";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export async function deleteTeamsApi(teams) {
  const data = {
    team: teams,
  };
  try {
    const response = await ApiInterface.instance.deleteTeams(data);
    return response;
  } catch (error) {
    if (error) {
      let errorMessage = error?.response?.data?.message;
      if (!!errorMessage) {
        withReactContent(Swal).fire({
          title: "Error",
          html: errorMessage,
        });
      }
    }
  }
}
